import './Cell.css';
import './AttackAnimation.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import TargetPlayUnit from "./TargetPlayUnit";
import TargetPlaySpell from "./TargetPlaySpell";
import MiddlewareAbility from "./MiddlewareAbility";
import Sleep from "./Sleep";
import {isMobile} from 'react-device-detect';
import {useSwipeable} from "react-swipeable";
import {SoundsService} from "../../../services/SoundsService";
import {sounds} from "../../../sounds/sound";
import {useActions} from "../../../hooks/useActions";
import {useEffect, useState} from "react";
import {useDrop} from "react-dnd";
import Stun from "./stun/Stun";
import CardContainer from "./CardContainer";

function Cell({tableKey, table, side}) {

    const {phase, playerAD, playerTable, playerHand} = useTypedSelector(state => state.game);
    const {showUnitAttack, showPlayUnitHover} = useTypedSelector(state => state.animation);
    const {tutorial} = useTypedSelector(state => state.auth);
    const {
        setPlayerAD,
        setTutorial,
        setPlayerTable,
        playCard,
        setPhase,
        setPlayerHand,
        setShowPlayUnitHover
    } = useActions();

    let [targetClass, setTargetClass] = useState('');

    if (phase === 'play_spell') {
        if (targetClass !== '') {
            setTargetClass('');
        }
    }

    let rootClasses = 'cell';
    if (showUnitAttack.tableKey !== null && showUnitAttack.tableKey === tableKey && showUnitAttack.side === side) {

        if (side === 'player') {
            if (showUnitAttack.damageToEnemy) {
                rootClasses += ' animate_slideOutUp_toEnemy animate_slideOutUp_toEnemy_' + tableKey;
            } else {
                rootClasses += ' animate_slideOutUp_Custom';
            }
        } else {
            if (showUnitAttack.damageToEnemy) {
                rootClasses += ' animate_slideOutUp_toPlayer animate_slideOutUp_toPlayer_' + tableKey;
            } else {
                rootClasses += ' animate_slideOutDown_Custom';
            }
        }
    }
    let wall = false;
    let stunCounter = 0;

    if (table[tableKey] !== 0 && table[tableKey] !== null && table[tableKey].card.ability !== null && table[tableKey].card.ability.type_effect === 'wall') {
        wall = true;
    }

    if (table[tableKey] !== 0 && table[tableKey] !== null && table[tableKey].effect !== undefined && table[tableKey].effect.stun !== undefined) {
        stunCounter = table[tableKey].effect.stun;
    }

    let activeAD = false;

    if (
        phase === 'play_card' && wall === false && stunCounter <= 0 && side === 'player' && table[tableKey] !== 0
        && table[tableKey] !== null && table[tableKey].sleep === false
    ) {
        activeAD = true;
    }

    rootClasses += ' cell_' + side + '_' + tableKey;

    if (playerAD[tableKey] === true && side === 'player') {
        rootClasses += ' cellReadyToAttack';
    }

    if (isMobile) {
        rootClasses += ' cellMobileZoom';
    }

    const handlers = useSwipeable({
        onSwipedDown: () => setDef(),
        onSwipedUp: () => setAttack()
    });

    const setAttack = () => {
        if (!activeAD) {
            return;
        }
        playerAD[tableKey] = true;
        setPlayerAD(playerAD);
        SoundsService.playSound(sounds.battle_unit_set_attack());
        // Tutorial
        if (tutorial.step === 'SelectAttack60') {
            tutorial.step = 'EndTurnBattle65';
            setTutorial(tutorial);
        }
        //
    }

    const setDef = () => {
        if (!activeAD) {
            return;
        }
        playerAD[tableKey] = false;
        setPlayerAD(playerAD);
        SoundsService.playSound(sounds.battle_unit_set_defence());
    }

    const toggleAttack = () => {
        if (!activeAD) {
            return;
        }
        if (playerAD[tableKey] === true) {
            setDef();
        } else {
            setAttack();
        }
    }

    const cardDropped = (item) => {

        if (side !== 'player' || table[tableKey] !== 0) {
            return;
        }

        delete playerHand[item.handKey];
        setPlayerHand(playerHand);

        playCard({card: item.card, handKey: item.handKey, target: {key: 'table_key', value: tableKey, side: side}});

        setPhase('play_unit');

        playerTable[tableKey] = {
            card: item.card,
            sleep: false
        }

        setPlayerTable(playerTable);

    }

    const [{isOver}, dropRef] = useDrop({
        accept: 'card_unit',
        drop: (item) => cardDropped(item),
        collect: (monitor) => ({
            isOver: monitor.isOver({shallow: true})
        }),
        hover: (item, monitor) => {
            for (let i = 0; i < 5; i++) {
                if (tableKey === i) {
                    showPlayUnitHover[i] = true;
                } else {
                    showPlayUnitHover[i] = false;
                }
            }

            setShowPlayUnitHover(showPlayUnitHover);
        },
    })

    useEffect(() => {
        if (!isOver) {
            // скидаємо масив
            setShowPlayUnitHover(Array(5).fill(false));
        }
    }, [isOver]);


    let targetClassPlayUnit = '';
    if (side === 'player') {
        if (showPlayUnitHover[tableKey]) {
            targetClassPlayUnit += ' cellActiveToDrop';
        } else if (showPlayUnitHover.includes(true)) {
            targetClassPlayUnit = ' cellUNActiveToDrop';
        }
    }

    let showADTargetClass = '';
    if (activeAD && playerAD[tableKey] === false && side === 'player' && phase === 'play_card') {
        showADTargetClass = 'animateCardBoxShadowReadyToSetAttack';
    }
    if (playerAD[tableKey] === true && side === 'player' && phase === 'play_card') {
        showADTargetClass = 'animateCardBoxShadowAttack';
    }
    if (phase === 'play_card') {
        targetClass = showADTargetClass;
    }

    return (
        <div ref={dropRef} className={rootClasses} onClick={() => {
            toggleAttack();
        }}>

            <MiddlewareAbility tableKey={tableKey} side={side} cell={table[tableKey]}/>
            <TargetPlayUnit tableKey={tableKey} table={table} side={side} addClass={targetClassPlayUnit}/>
            <TargetPlaySpell tableKey={tableKey} table={table} side={side} action={setTargetClass}/>


            {(table[tableKey] !== 0 && table[tableKey] !== null && table[tableKey].sleep === true) ?
                <Sleep/> : <div></div>
            }
            {(stunCounter > 0)
                ? <Stun amount={stunCounter}/>
                : <div></div>
            }

            {(table[tableKey] === 0 || table[tableKey] === null) ?
                <div></div>
                :
                <section className="buc_container" {...handlers}>
                    <CardContainer side={side} tableKey={tableKey} card={table[tableKey].card}
                                   targetClass={targetClass}/>
                </section>


            }

        </div>
    )
        ;
}

export default Cell;